import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import theme from 'config/themes';

const usePageTitle = (pageTitle) => {
  const location = useLocation();
  const appName = `${theme.companyName}`;

  useEffect(() => {
    const title = pageTitle ? `${pageTitle} - ${appName}` : appName;
    document.title = title;
  }, [appName, pageTitle, location.pathname]);
};

export default usePageTitle;
